(() => {
  const title = document.currentScript.dataset.headingTitle;
  const ensureHeading = () => {
    if (!document.body || !document.querySelector('iframe[title="Embedded form"]') || document.querySelector('h1')) return;
    const heading = document.createElement('h1');
    heading.className = 'visually-hidden';
    heading.dataset.embeddedPageHeading = '';
    heading.textContent = title;
    heading.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;padding:0;margin:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
    document.body.appendChild(heading);
  };
  const observe = () => {
    ensureHeading();
    new MutationObserver(ensureHeading).observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, {once: true});
  } else {
    observe();
  }
})();
